import { render, staticRenderFns } from "./App.vue?vue&type=template&id=aec63c9c&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=aec63c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec63c9c",
  null
  
)

export default component.exports